import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTH_FEATURE_KEY, AuthState, authAdapter } from './auth.reducer';

// Lookup the 'Auth' feature state managed by NgRx
export const selectAuthState =
  createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

const { selectAll, selectEntities } = authAdapter.getSelectors();

export const selectAuthLoaded = createSelector(
  selectAuthState,
  (state: AuthState) => state.loaded
);

export const selectError = createSelector(
  selectAuthState,
  (state: AuthState) => state.error
);

export const getUserPermissions = createSelector(
  selectAuthState,
  (state: AuthState) => state.permissions
);

export const getUser = createSelector(
  selectAuthState,
  (state: AuthState) => state.user
);

export const getRole = createSelector(
  selectAuthState,
  (state: AuthState) => state.role
);
